import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../../../context/LanguageContext';
import {
  CONTACT_PHONE_DISPLAY,
  CONTACT_PHONE_TEL,
} from '../../../constants/contact';
import './Footer.css';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLanguage();
  
  const scrollToSection = (sectionId: string) => {
    // Eğer Thank You sayfasındaysak, önce ana sayfaya git
    if (location.pathname === '/thank-you') {
      navigate('/');
      // Ana sayfaya gittikten sonra section'a scroll yap
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // Ana sayfadaysak direkt scroll yap
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="footer">
      <Container>
        <Row className="py-5">
          <Col lg={4} className="mb-4 mb-lg-0">
            <div className="footer-brand">
              <div className="footer-logo mb-3">
                <img 
                  src="assets/img/logo.png" 
                  alt="Doç. Dr. Ayşe Sezim Logo" 
                  className="footer-logo-img"
                  onClick={() => scrollToSection('home')}
                  style={{ cursor: 'pointer' }}
                />
              </div>
              <p className="text-muted">
                Doç. Dr. Ayşe Sezim Şafak, kepçe kulak tedavisinde uzman doktor olarak modern cerrahi teknikler ve kişiselleştirilmiş bakım sunmaktadır.
              </p>
              <div className="social-links">
                <a href="https://www.instagram.com/draysesezim/" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="https://www.facebook.com/draysesezim/" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-facebook"></i>
                </a>
                <a href="https://www.youtube.com/@Draysesezim" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-youtube"></i>
                </a>
              </div>
            </div>
          </Col>

          <Col lg={2} className="mb-4 mb-lg-0">
            <h5 className="text-gold mb-3">{t('footer.services')}</h5>
            <ul className="footer-links">
              <li>
                <a href="#treatments" onClick={(e) => { e.preventDefault(); scrollToSection('treatments'); }}>
                  Kepçe Kulak Tedavisi
                </a>
              </li>
              <li>
                <a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>
                  Hakkımızda
                </a>
              </li>
              <li>
                <a href="#testimonials" onClick={(e) => { e.preventDefault(); scrollToSection('testimonials'); }}>
                  Yorumlar
                </a>
              </li>
              <li>
                <a href="#faq" onClick={(e) => { e.preventDefault(); scrollToSection('faq'); }}>
                  SSS
                </a>
              </li>
            </ul>
          </Col>

          <Col lg={3} className="mb-4 mb-lg-0">
            <h5 className="text-gold mb-3">{t('footer.procedures')}</h5>
            <ul className="footer-links">
              <li>Kepçe Kulak Ameliyatı</li>
              <li>Otoplasti</li>
              <li>Kulak Estetiği</li>
              <li>Takip ve Bakım</li>
            </ul>
          </Col>

          <Col lg={3}>
            <h5 className="text-gold mb-3">{t('footer.contactInfo')}</h5>
            <ul className="footer-links">
              <li>
                <i className="fas fa-map-marker-alt text-gold me-2"></i>
                <a 
                  href="https://www.google.com/maps?gs_lcrp=EgZjaHJvbWUyBggAEEUYOdIBCDMxNTVqMGoxqAIAsAIA&um=1&ie=UTF-8&fb=1&gl=tr&sa=X&geocode=KVfeaOrkIcsUMZPsHHh4Kx1Y&daddr=Sahray%C4%B1+Cedit,+Atat%C3%BCrk+Cd.+No:+69,+34734+Kad%C4%B1k%C3%B6y/%C4%B0stanbul" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  style={{color: '#ccc', textDecoration: 'none'}}
                >
                  {t('footer.location')}
                </a>
              </li>
              <li>
                <i className="fas fa-phone text-gold me-2"></i>
                <a href={`tel:${CONTACT_PHONE_TEL}`} style={{color: '#ccc', textDecoration: 'none'}}>{CONTACT_PHONE_DISPLAY}</a>
              </li>
              <li>
                <i className="fas fa-envelope text-gold me-2"></i>
                <a href="mailto:info@draysesezim.com" style={{color: '#ccc', textDecoration: 'none'}}>info@draysesezim.com</a>
              </li>
            </ul>
          </Col>
        </Row>

        <hr className="footer-divider" />

        <Row className="py-3">
          <Col md={6} className="text-center text-md-start">
            <p className="mb-0 text-muted">
              {t('footer.copyright')}
            </p>
          </Col>
          <Col md={6} className="text-center text-md-end">
            <p className="mb-0 text-muted">
              {t('footer.designedBy')}{' '}
              <a href="https://www.terapimedia.com" target="_blank" rel="noopener noreferrer" className="text-gold">
                Terapi
              </a>
            </p>
          </Col>
        </Row>

        <Row className="py-2">
          <Col xs={12}>
            <div className="medical-disclaimer">
              <p className="text-center text-muted small mb-0">
                {t('footer.medicalDisclaimer')}
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
